


import { NgModule, Component, enableProdMode } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BrowserModule  } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';







@Component({
  selector: 'app-tdo-icon-picker',
  templateUrl: './tdo-icon-picker.component.html',
  styleUrls: ['./tdo-icon-picker.component.scss']
  
})
export class TdoIconPickerComponent {  

  constructor(private dialogRef: MatDialogRef<TdoIconPickerComponent>){ }

zdataSource: any;



ngOnInit(): void {
   this.loadListOFImages();
}



onImageClick( i: any)
{
  //console.log(i);

  this.dialogRef.close(i);

}


loadListOFImages()  {
  

  
  fetch('assets/icons/valid-values/valid-value-icons.json').then(res => res.json())
  .then(iconList=>  {

    

    this.zdataSource = iconList.iconFolders[0].iconFolders[0].iconFolders;



  }
    
    
  );



}

}
